import r from "styled-components";
import { Base as p } from "./atoms-v2777.js";
import { Grid as n } from "./atoms-v216.js";
import { breakpoints as o } from "./atoms-v2125.js";
import { Column as d } from "./atoms-v212.js";
const c = r(n)`
  ${p}

  color: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.text.light.primary")};
  padding-block: 20px;
  row-gap: 16px;

  @media ${o.medium} {
    padding-block: 40px;
  }

  @media ${o.large} {
    padding-block: 0;
    row-gap: 0;
  }
`, x = r.div`
  ${({ theme: i }) => {
  var a;
  return (a = i == null ? void 0 : i.get("tokens.heading.02")) == null ? void 0 : a.toJS();
}}

  @media ${o.medium} {
    ${({ theme: i }) => {
  var a;
  return (a = i == null ? void 0 : i.get("tokens.heading.03")) == null ? void 0 : a.toJS();
}}
  }

  @media ${o.large} {
    margin-bottom: 0;
  }

  @media ${o.xLarge} {
    ${({ theme: i }) => {
  var a;
  return (a = i == null ? void 0 : i.get("tokens.heading.04")) == null ? void 0 : a.toJS();
}}
  }
`, $ = r(d)`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  @media ${o.medium} {
    display: grid;
    gap: 6px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${o.large} {
    gap: 12px;
  }

  @media ${o.max} {
    grid-template-columns: repeat(3, 1fr);
  }
`, k = r.div`
  ${({ theme: i }) => {
  var a;
  return (a = i == null ? void 0 : i.get("tokens.helper.productive")) == null ? void 0 : a.toJS();
}}

  align-items: center;
  background: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.surface.light.layer01")};
  border-radius: 1000px;
  display: flex;
  height: 24px;
  justify-content: center;
  padding-inline: 8px;
  white-space: nowrap;

  @media ${o.medium} {
    ${({ theme: i }) => {
  var a;
  return (a = i == null ? void 0 : i.get("tokens.body.expressive")) == null ? void 0 : a.toJS();
}}
    background: transparent;
    border-radius: 0;
    display: block;
    height: auto;
    padding-inline: 0;
    white-space: normal;
  }
`, b = r(d)`
  border-top: 1px solid ${({ theme: i }) => i == null ? void 0 : i.get("tokens.border.light.light")};
  display: none;
  padding-bottom: 24px;

  @media ${o.large} {
    display: block;
  }
`;
export {
  c as Amenities,
  $ as AmenitiesList,
  k as Amenity,
  b as Header,
  x as Title
};
